<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="RightOfWithdrawalModal"
    :width="800"
    :title="$t('RightOfWithdrawal.General.Title')"
  >
    <div class="pt-5">
      <RightOfWithdrawalComponent />
    </div>
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import RightOfWithdrawalComponent from '@/components/RightOfWithdrawalComponent'

export default {
  name: 'RightOfWithdrawalModal',
  components: {
    ToastModal,
    RightOfWithdrawalComponent,
    ToastModalFooter
  },
  methods: {
    toggleActivation (isOpen = true) {
      this.$refs.modal.toggleActivation(isOpen)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style lang="postcss" scoped>
.right-of-withdrawal-component {
  >>> &-subject-title {
    @apply text-center;
  }
}
</style>
